import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import './ServicesPage.css';

function ServicesPage({ onLoginClick }) {
  const services = [
    {
      title: 'Transport Requests',
      description:
        'Farmers request transport through WhatsApp (English, French, or Pidgin). The bot guides you through product, quantity, route, and date, then shows a calculated quote before you confirm.',
      image: 'https://images.unsplash.com/photo-1685586784798-abbf744c69c1?w=800',
      isLogo: false,
      features: ['Guided WhatsApp ordering', 'Works on basic phones', 'Multi-language support', 'Quote before you confirm'],
    },
    {
      title: 'Dispatch Dashboard',
      description:
        'Administrators manage orders, assign drivers, and review trip status on the web dashboard. Status updates as drivers confirm pickup and delivery on WhatsApp.',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800',
      isLogo: false,
      features: ['Order management', 'Driver assignment', 'Trip status on dashboard', 'Basic analytics'],
    },
    {
      title: 'Trip Tracking',
      description:
        'Trips are logged with driver assignment, pickup and delivery timestamps, and distance where recorded. Farmers can check recent order status via WhatsApp; admins see the full picture on the dashboard.',
      isMapIcon: true,
      isLogo: true,
      features: ['Pickup confirmation', 'Delivery timestamps', 'Distance logging', 'Order status updates'],
    },
    {
      title: 'Smart Pricing',
      description:
        'Pricing Grid V1 calculates transport cost from distance, weight or volume, road type, and cold-chain needs. Each request gets its own quote in WhatsApp before booking — transparent FCFA totals.',
      image: 'https://upload.wikimedia.org/wikipedia/commons/e/ed/Transport_de_marchandises_par_tricycle_01.jpg',
      isLogo: false,
      features: ['Distance-based rates', 'Weight/volume pricing', 'Cold chain options', 'Personalized quotes'],
    },
  ];

  return (
    <Layout onLoginClick={onLoginClick}>
      <div className="services-page">
        <section className="services-hero">
          <div className="services-hero-bg" />
          <div className="services-hero-overlay" />
          <div className="services-hero-content">
            <h1>Our Services</h1>
            <p>End-to-end agricultural logistics — from farm gate to market stall</p>
          </div>
        </section>

        <section className="services-intro">
          <div className="services-intro-inner">
            <h2>How FarmFleet Works</h2>
            <p>
              FarmFleet connects farmers with organized transport through WhatsApp ordering and an
              admin dispatch dashboard. The platform supports ordering, driver assignment, trip logging,
              and calculated pricing — with ongoing improvements as we expand coverage.
            </p>
          </div>
        </section>

        <section className="services-grid">
          {services.map((service, index) => (
            <article key={index} className="service-article">
              <div className={`service-article-content ${index % 2 === 1 ? 'reversed' : ''}`}>
                <div className="service-article-text">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <ul className="service-features">
                    {service.features.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                </div>
                <div className={`service-article-image ${service.isLogo ? 'service-article-image--logo' : ''}`}>
                  {service.isMapIcon ? (
                    <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="map-icon" aria-hidden="true">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/>
                    </svg>
                  ) : (
                    <img src={service.image} alt={service.title} />
                  )}
                </div>
              </div>
            </article>
          ))}
        </section>

        <section className="services-cta">
          <div className="services-cta-inner">
            <h2>Ready to Get Started?</h2>
            <p>Contact us to learn more about our transport services.</p>
            <Link to="/contact" className="btn-contact">Contact Us</Link>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default ServicesPage;
